
export const getAliasFromPath = (fullURL: string) => {
  // idk why it was deleted
  const lastSlashIndex = fullURL.lastIndexOf("/");
  const searchIndex = fullURL.indexOf("?")
  const lastIndex = searchIndex >= 0 ? searchIndex : fullURL.length
  return fullURL.substring(lastSlashIndex + 1, lastIndex);
}